import { Component, Input, OnInit } from '@angular/core';
import { TitleLineConfigurations } from '../title/title.configurations';
import { CommonModule } from '@angular/common';
import { TitleComponent } from '../title/title.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { NewActionTaxonomyCategoryComponent } from '../new-action-taxonomy-category/new-action-taxonomy-category.component';

@Component({
  selector: 'kla-new-action-taxonomy',
  templateUrl: './new-action-taxonomy.component.html',
  styleUrls: ['./new-action-taxonomy.component.scss'],
  standalone: true,
  imports: [ CommonModule, TitleComponent, MatExpansionModule, NewActionTaxonomyCategoryComponent ]
})
export class NewActionTaxonomyComponent implements OnInit {

  @Input()
  public mainSiteColor: string;


  @Input()
  public config: any;

  @Input()
  public lineConfig: TitleLineConfigurations;

  @Input() collapseChildren: boolean = false;

  panelOpenState: boolean = false;
  color: string;

  constructor() { }

  get titleConfig () {
    return {
      header: this.config.title,
      title: this.config.title,
      description: this.config.description,
      footer: '',
      color: this.mainSiteColor,
      badges: this.config.badges,
    }
  }

  ngOnInit(): void {
    setTimeout(() => {
    })
  }

}
